import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type ConfirmOption = {
    name: string;
    icon?: string;
    bgColor?: string;
    disabled?: boolean;
    subtext?: string;
    rightText?: string;
    value?: any;
};

type ConfirmDialogData = {
    title: string;
    text: string;
    confirm: string;
    cancel: string;
    options?: ConfirmOption[];
    close?: boolean;
    radio?: boolean;
    multiSelect?: boolean;
};

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false,
})
export class ConfirmDialogComponent implements AfterViewInit {
    protected readonly ConfirmDialogResult = ConfirmDialogResult;

    @Output() optionChosen = new EventEmitter<{ name: string; confirm?: boolean }>();

    @ViewChild('confirmButton') confirmButton: ElementRef<HTMLButtonElement>;

    selectedOption: any = null;
    selectedOptions: ConfirmOption[] = [];

    constructor(
        public dialogRef: MatDialogRef<ConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
    ) {}

    ngAfterViewInit(): void {
        if (this.data.confirm && !this.data.radio) {
            this.confirmButton.nativeElement?.focus();
        }
    }

    optionClicked(option: ConfirmOption, confirm = false): void {
        if (option.disabled) {
            return;
        }

        if (this.data.multiSelect) {
            const index = this.selectedOptions.findIndex(o => o.name === option.name);

            if (index > -1) {
                this.selectedOptions.splice(index, 1);
            } else {
                this.selectedOptions.push(option);
            }
        } else {
            this.optionChosen.emit({ ...option, confirm });
        }
    }

    isSelected(option: { name: string }): boolean {
        return this.selectedOptions.some(o => o.name === option.name);
    }

    onConfirm(): void {
        if (this.data.multiSelect) {
            this.dialogRef.close(this.selectedOptions);
        } else {
            this.dialogRef.close(ConfirmDialogResult.Primary);
        }
    }
}

export enum ConfirmDialogResult {
    Cancelled = 'Cancelled',
    Primary = 'Primary',
    Secondary = 'Secondary',
}
